/* eslint-disable import/no-anonymous-default-export */
export default {
  API_ENDPOINT: " https://pure-journey-84358.herokuapp.com/api",
  TOKEN_KEY: "blogful-client-auth-token",
};
